import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import * as serviceWorker from "./serviceWorker";
import "./css/App.css";
import "./css/index.css";
import "./css/responsive.css";
import "./css/style.css";
import "./css/styles.css";
import "./css/variables.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { LabelProvider } from "./context/label/labelProvider";
import { initOfflineListener } from "./modules/offline/offlineAlert";

window.addEventListener("load", function () {
   initOfflineListener()
});

ReactDOM.render(
   <Provider store={store}>
      <LabelProvider>
         <Root />
      </LabelProvider>
   </Provider>,
   document.getElementById("root")
);
serviceWorker.unregister();
